export default (props) => {
  console.log(props);
  return null;
};
